import { UseMutationOptions } from '@tanstack/react-query';

import { CommunicationType } from 'domains/content/types';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';

import MutationKeys from './keys';

export type UpdateSmsInput = {
    applicationsAccess: string;
    name: string;
    communicationType: CommunicationType;
    content: string;
    contentMultilingual?: Record<string, string>;
    autoResponsesMultilingual?: Record<string, any[]>;
};

const useUpdateSms = (smsId: string, mutateOptions: UseMutationOptions<unknown, Error, UpdateSmsInput>) =>
    useMutation<UpdateSmsInput>(
        MutationKeys.UPDATE_SMS,
        new PathWithID(CuredApiPaths.SMS, Number(smsId)),
        mutateOptions,
        ApiMethods.PUT
    );

export default useUpdateSms;
